import { Component, Input, TemplateRef } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-page-container",
  templateUrl: "./page-container.component.html",
  standalone: true,
  imports: [CommonModule],
  styleUrls: ["./page-container.component.scss"],
})
export class PageContainerComponent {
  @Input() navTemplate!: TemplateRef<unknown>;
  @Input() contentTemplate!: TemplateRef<unknown>;
  @Input() gradient: "1" | "2" = "1";
}
